import React, { useState } from "react";
import './styles.css'
import { useNavigate, useSearchParams } from "react-router-dom";
import { Settings } from "solar-icon-set/settingsfinetuning";
import { PaperAdd } from "solar-icon-set/notes";
import { useDispatch } from 'react-redux';
import { setLogoutUser } from '../../redux/userSlice';
import { useUser } from '../../redux/useStore';
import { ReactComponent as LogoutIconSVG } from '../../assets/logout.svg'
import { ReactComponent as ChanakyaLogo } from '../../assets/chanakyaLogo.svg'
import { Colors } from "../../utils/constants/colors";
import { useOneSignalUser } from '../../hooks/useOneSignalUser';
import { CodeSquare } from "solar-icon-set/networkitprogramming";
// import { MenuDots } from "solar-icon-set/essentionalui";
import { IoIosMenu, IoMdClose } from "react-icons/io";

function NavigationBar() {


  const [searchParams] = useSearchParams()
  const pathname = window.location.pathname

  const heading = searchParams.get('title') ||   'Dashboard'

  const dispatch = useDispatch();
  const user = useUser();
  const navigate = useNavigate()
  const { logoutUser } = useOneSignalUser();



  const [showDropdown, setShowDropdown] = useState(false);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleLogout = async () => {
    try {
      // First logout from OneSignal
      await logoutUser();

      // Then proceed with app logout
      dispatch(setLogoutUser());
      navigate('/login');
      setShowDropdown(false);
      localStorage.clear();

    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const tabs = [
    {
      id: 1,
      name: 'Subjects',
      icon: (color: string) => (<PaperAdd size={20} color={color} />),
      link: '/subject',
      allowedRoles: ['admin', 'teacher', 'student']
    },
    {
      id: 1,
      name: 'Assessments',
      icon: (color: string) => (<PaperAdd size={20} color={color} />),
      link: '/assessments',
      allowedRoles: ['admin', 'teacher', 'student']
    },
    // {
    //   id: 0,
    //   name: 'Shop',
    //   icon: (color: string) => (<Shop2 size={20} color={color} />),
    //   link: '/shop',
    //   allowedRoles: ['admin', 'student']
    // },
    {
      id: 3,
      name: 'Settings',
      icon: (color: string) => (<Settings size={20} color={color} />),
      link: '/settings',
      allowedRoles: ['admin', 'student']
    }, {
      id: 4,
      name: 'Renderer',
      icon: (color: string) => (<CodeSquare size={20} color={color} />),
      link: '/renderer',
      allowedRoles: ['admin', 'super_admin']
    }
  ]

  const isActiveTab = (link: string) => {
    return link.split('/')[1] === pathname.split('/')[1]
  }


  return (
    <div className="drawer">

      <div className="pc_drawer">
        <div className="drawer__header">
          <ChanakyaLogo width={200} height={22} />
        </div>

        <div className="drawer__content big-screen">
          {
            tabs.map(tab => (
              tab.allowedRoles.includes(user?.role || '') &&
              <div key={tab.id}
                className={`drawer__content__tab ${isActiveTab(tab.link) ? 'active' : ''}`}
                onClick={() => navigate(tab.link)}>
                {tab.icon(isActiveTab(tab.link) ? 'white' : 'gray')}
                <span>{tab.name}</span>
              </div>
            ))
          }
        </div>



        <div className="drawer__footer">

          <div className="drawer_user_tab">
            {/* <UserCircle size={25} /> */}
            <div className="user_info" onClick={() => setShowDropdown(!showDropdown)}>
              <span style={{ fontSize: 14, color: 'gray' }}>Hello,</span>
              <span style={{ fontSize: 18, color: 'black' }}>{user?.firstName || 'User'}</span>

            </div>

          </div>


          {showDropdown && (
            <div className="dropdown-overlay" onClick={() => setShowDropdown(false)}>
              <div className="logout-dropdown">
                <div className="dropdown-option logout-option" onClick={handleLogout}>
                  <LogoutIconSVG width={20} height={20} />
                  <span>Logout</span>
                </div>

              </div>
            </div>
          )}
        </div>
      </div>

      <div className="mobile_drawer">
        <div className="mobile_drawer__header">
          <IoIosMenu size={33} color={Colors.primary} onClick={() => setIsDrawerOpen(true)} />
          <h3 className="mobile_drawer__header__title">{heading}</h3>
        </div>

        <div className="mobile_drawer_sidebar">
          {
            isDrawerOpen && <div className="mobile_drawer_sidebar__backdrop" onClick={() => setIsDrawerOpen(false)}></div>
          }

          {/* <div className={`mobile_drawer_sidebar__backdrop ${isDrawerOpen ? 'active' : ''}`} onClick={() => setIsDrawerOpen(false)} /> */}


          <div className={`mobile_drawer_sidebar__content ${isDrawerOpen ? 'active' : ''}`}>
            <div className="mobile_drawer_sidebar__content_header">
              <ChanakyaLogo width={200} height={22} />
              <IoMdClose size={30} onClick={() => setIsDrawerOpen(false)} />
            </div>

            <br />
            {
              tabs.map(tab => (
                tab.allowedRoles.includes(user?.role || '') &&
                <div key={tab.id}
                  className={`drawer__content__tab ${isActiveTab(tab.link) ? 'active' : ''}`}
                  onClick={() => {
                    navigate(tab.link)
                    setIsDrawerOpen(false)
                  }}>
                  {tab.icon(isActiveTab(tab.link) ? 'white' : 'gray')}
                  <span>{tab.name}</span>
                </div>
              ))
            }

          </div>
        </div>
      </div>

    </div>
  );
}

export default NavigationBar;